import { MAX_FILE_SIZE, ALLOWED_FILE_TYPES } from '@/app/(dashboard)/constants'
import { z } from 'zod'

const FILE_ERROR_MESSAGE = 'File exceeds the limit of 3,000 pages or 500 MB.'
const FILE_TYPE_ERROR_MESSAGE = 'File must be a PDF, DOC, or DOCX file.'

export const step1Schema = z.object({
  file: z
    .instanceof(File)
    .optional()
    .refine(
      (file) => {
        if (!file) return false

        return file.size < MAX_FILE_SIZE
      },
      {
        message: FILE_ERROR_MESSAGE,
      }
    )
    .refine(
      (file) => {
        if (!file) return false

        const fileExtension = file.name.split('.').pop()?.toLowerCase()

        return fileExtension && ALLOWED_FILE_TYPES.includes(fileExtension)
      },
      {
        message: FILE_TYPE_ERROR_MESSAGE,
      }
    ),
  location: z
    .object({
      type: z.enum(['dashboard', 'folder', 'project', 'document']),
      id: z.string().or(z.number()),
      name: z.string().optional(),
    })
    .refine(
      (location) => {
        if (!location) return false

        return Boolean(location.id)
      },
      {
        message: 'Location is required',
      }
    ),
})
